module.exports = __webpack_public_path__ + "static/media/footer_bg_new.0b86c60d.jpg";